import { useNavigate } from "react-router-dom";
import SEO from "@/components/SEO";
import { transitionTo } from "@/components/Transition";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <main className="flex min-h-[100svh] flex-col items-center justify-center px-[6vw] text-center" data-testid="not-found-page">
      <SEO
        title="404 — Wrong Route | OA Holding CO LTD."
        description="This route does not exist. Return to OA Holding."
        path="/404"
      />
      <p className="font-display text-[34vw] font-black leading-none tracking-tighter text-outline-faint md:text-[18vw]">
        404
      </p>
      <p className="mt-2 font-display text-3xl font-black uppercase tracking-tighter md:text-5xl">
        Wrong route.
      </p>
      <p className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-smoke">
        Let&rsquo;s get you moving again.
      </p>
      <a
        href="/"
        onClick={(e) => {
          e.preventDefault();
          transitionTo(navigate, "/");
        }}
        className="mt-10 border border-amber/60 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-amber transition-colors duration-300 hover:bg-amber hover:text-ink"
        data-testid="not-found-home-link"
      >
        Home
      </a>
    </main>
  );
}
